<!--
    tip:  compare w/ src/pages/admin/reports/Index.vue
-->
<template>
  <main-layout
    margin-top="14px"
    regular
  >
    <non-integrated />
  </main-layout>
</template>
<script>

import integrable from '@/components/mixins/integrable';
import NonIntegrated from './NonIntegrated';

export default {
  components: {
    NonIntegrated,
  },
  mixins: [integrable],
};
</script>
